import { render, staticRenderFns } from "./ExplanatoryVideo.vue?vue&type=template&id=1e675dd7&scoped=true&lang=pug&"
import script from "./ExplanatoryVideo.vue?vue&type=script&lang=ts&"
export * from "./ExplanatoryVideo.vue?vue&type=script&lang=ts&"
import style0 from "./ExplanatoryVideo.vue?vue&type=style&index=0&id=1e675dd7&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e675dd7",
  null
  
)

export default component.exports